import React, { useState } from "react";
import axios from "axios";
import { Done, DoneAll, GetApp } from "@material-ui/icons";
import Fab from "@material-ui/core/Fab";
import LazyLoad from "react-lazy-load";

import { ErrorData } from "../../helpers/helper";
import ReplyIcon from "@material-ui/icons/Reply";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles({
  myMessage: {
    float: "right",
    margin: 5,
  },
  otherMessage: {
    float: "left",
    margin: 5,
  },
});
const PictureMessage = ({
  chat,
  UserId,
  reply,
  deleteMessage,
  doc,
  prescriptionFileStyle,
  prescriptionFileStyle2,
}) => {
  const [file, setFile] = useState({});
  const [downloaded, setDownloaded] = useState(false);
  const owner = parseInt(UserId) === parseInt(chat.user_id);
  const [process, setProcess] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const classes = useStyles();

  const getFile = () => {
    if (downloading) return;
    if (downloaded) {
      download(file);
    } else {
      setDownloading(true);
      // var token = getAuthorization();
      // const headers = {};
      // headers['Authorization'] = 'Bearer ' + token;
      axios({
        url: chat.file,
        // headers: headers,
        method: "GET",
        responseType: "blob",
        onDownloadProgress: (ProgressEvent) => {
          setProcess((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((response) => {
          setDownloaded(true);
          setFile(response.data);
          download(new Blob([response.data]));
        })
        .catch((err) => {
          setDownloading(false);
          setProcess(0);
          console.log(err);
          ErrorData("خطایی رخ‌داده است. لطفا دوباره تلاش کنید.");
        });
    }
  };

  const download = (file) => {
    // const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = `${chat.file}`;
    link.target = "_blank";
    link.setAttribute("download", chat.file.split("/").slice(-1)[0]);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <div key={chat.key} className={owner ? "chat_item me" : "chat_item"} >
      <div className="main_item_chat" style={prescriptionFileStyle}>
        <div className="text_chat" style={prescriptionFileStyle2}>
          <p onClick={download}>
            <p>{chat.message}</p>
            <LazyLoad height={200} offsetVertical={200}>
              <img
                style={{ width: 200, height: 200, borderRadius: 8 }}
                src={chat.file}
                alt="no image"
                userId={UserId}
              />
            </LazyLoad>

            {doc}
          </p>
        </div>
        <div className="clearfix" />
        <time>{chat.created_at}</time>
        {owner ? (
          <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
        ) : null}
        <div className="clearfix" />
      </div>
      {owner ? (
        <div className="control_message" style={{ display: "inline" }}>
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
          <DeleteIcon
            className="delete_message"
            onClick={() => deleteMessage(chat)}
          />{" "}
        </div>
      ) : (
        <div
          className="control_message"
          style={{ display: "inline", float: "left" }}
        >
          <ReplyIcon className="reply_message" onClick={() => reply(chat)} />
        </div>
      )}
      <div className="clearfix" />
    </div>
  );
};

export default PictureMessage;
